var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNonactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.038,
    height: 26,
    viewBox: "0 0 26.038 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1573",
    "data-name": "Group 1573",
    transform: "translate(-749 -245)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1555",
    "data-name": "Group 1555",
    transform: "translate(717.256 245)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1552",
    "data-name": "Group 1552",
    transform: "translate(36.295)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1551",
    "data-name": "Group 1551",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1003",
    "data-name": "Path 1003",
    d: "M116.207,0a5.615,5.615,0,1,0,5.615,5.615A5.612,5.612,0,0,0,116.207,0Z",
    transform: "translate(-110.592)",
    fill: "red"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1554",
    "data-name": "Group 1554",
    transform: "translate(31.744 11.88)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1553",
    "data-name": "Group 1553",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1004",
    "data-name": "Path 1004",
    d: "M44.1,205.824H39.723a7.983,7.983,0,0,0-7.979,7.979v3.251a.871.871,0,0,0,.887.887H51.189a.871.871,0,0,0,.887-.887V213.8A7.983,7.983,0,0,0,44.1,205.824Z",
    transform: "translate(-31.744 -205.824)",
    fill: "red"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_109",
    "data-name": "Ellipse 109",
    transform: "translate(764.038 260)",
    fill: "red",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 4.5,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonactive);
export default __webpack_public_path__ + "static/media/nonactive.e82f57119a62e99e979a82e848972be0.svg";
export { ForwardRef as ReactComponent };